import {
  Box,
  HStack,
  Icon,
  Image,
  SkeletonText,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiInstanceLine } from "@remixicon/react";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ShareLinkModal from "../components/ShareLinkModal";
import { BlogInterface } from "../constants/Blog";
import useCustomToast from "../lib/useCustomToast";
import { useDividerColor } from "../themes/colors";
import { axiosPublic } from "../utils/AxiosInstance";
import { formatDate } from "../utils/helperFunction";
import { MetaTag } from "../utils/MetaTag";

const BlogDetail = () => {
  const { slug } = useParams();
  const [data, setData] = useState<BlogInterface | undefined>(undefined);
  const [loaded, setLoaded] = useState<boolean>(false);
  const toast = useCustomToast();
  const dividerColor = useDividerColor();

  useEffect(() => {
    const decodedSlug = decodeURIComponent(slug || "");

    axiosPublic
      .get(`/v1/landing/post/${decodedSlug}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [slug]);

  return (
    <Box
      maxW={"966px"}
      mx={"auto"}
      py={{ base: "20px", md: "40px", lg: "60px" }}
      px={{
        base: "12px",
        sm: "24px",
        md: "32px",
        lg: "40px",
        xl: "48px",
        "2xl": 0,
      }}
    >
      <MetaTag
        title={data?.title || "Berita BisnisLink"}
        description={data?.preview || "Nikmati berita terbaru dari BisnisLink"}
        image={
          data?.thumbnail
            ? `${process.env.REACT_APP_MEDIA_URL}${data?.thumbnail}`
            : undefined
        }
      />

      <VStack spacing={"30px"}>
        <HStack justify={"center"}>
          <Box
            display={"inline-flex"}
            bg={"#FED7D7"}
            as={"div"}
            fontSize={"14px"}
            textTransform={"uppercase"}
            color={"secondary"}
            rounded={"4px"}
            p={"4px 8px"}
            gap={"4px"}
          >
            <Icon as={RiInstanceLine} />

            <Text textStyle={"h-xs-secondary"}>{data?.category_name}</Text>
          </Box>

          <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
            <Text
              as={"span"}
              // textStyle={"h-sm-gray50"}
              textStyle={"b-reg-sb"}
              variant={"secondary"}
            >
              {data?.posted_date && formatDate(data?.posted_date)}
            </Text>
          </SkeletonText>
        </HStack>

        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
          <Text textStyle={"h-title"} textAlign={"center"}>
            {data?.title}
          </Text>
        </SkeletonText>

        <Image
          rounded={"8px"}
          objectFit={"cover"}
          src={
            data?.thumbnail
              ? `${process.env.REACT_APP_MEDIA_URL}${data?.thumbnail}`
              : ""
          }
          alt={data?.title || "Foto Blog"}
          w={"full"}
          h={{ base: "300px", md: "425px" }}
        />

        <HStack
          w={"full"}
          // borderBottom={"1px solid #F2F3F5"}
          borderBottomWidth={"1px"}
          borderBottomColor={dividerColor}
          pb={"30px"}
          justify={"space-between"}
          alignItems={"center"}
        >
          <Box>
            <Text alignItems={"start"} textStyle={"b-reg-sb"}>
              Admin BisnisLink
            </Text>

            {data?.updated_at && (
              <Text textStyle={"b-reg"}>
                Disunting {data?.updated_at && formatDate(data?.updated_at)}
              </Text>
            )}
          </Box>

          <ShareLinkModal
            buttonText="Bagikan"
            iconSize="20px"
            data={`${process.env.REACT_APP_API_URL}/v1/sharelink/blog/${data?.id}`}
          />
        </HStack>

        <Box px={2}>{parse(`${data?.content}`)}</Box>
      </VStack>
    </Box>
  );
};

export default BlogDetail;
